import { databases } from "@/lib/appwrite";
import { Query } from "appwrite";

const DATABASE_ID = import.meta.env.VITE_APPWRITE_DATABASE_ID;
const PROFILE_COLLECTION_ID = import.meta.env.VITE_WORKER_PROFILE_COLLECTION_ID;

export async function getSubordinateUserIds(supervisorUserId: string): Promise<string[]> {
    const response = await databases.listDocuments(
        DATABASE_ID,
        PROFILE_COLLECTION_ID,
        [Query.equal('idSupervisor', supervisorUserId), Query.limit(500)]
    );
    return response.documents.map(doc => doc.userId);
}